export default {
    // 分页获取贷款列表
    getMortgageRollingList: "/mortgage/getMortgageRollingList",
    // 新增贷款主合同
    saveMortgageRolling: "/mortgage/saveMortgageRolling",    
    // 更新贷款主合同
    updateMortgageRolling: "/mortgage/updateMortgageRolling",    
    // 根据rollId获取贷款详情
    getMortgageRollDetail: "/mortgage/getRollDetail",    
    // 批量删除贷款合同
    delMortgageRolling: "/mortgage/delMortgageRolling",    
    // 导入excel
    importMortgageRollingExcel: "/mortgage/importRollingExcel",
    // vendor检索
    searchMortgageVendorType: "/v2/es/vendor/searchVendorType",
    // 贷款方式字典
    getMortgageLoanType: "/mortgage/getLoanType",
    // 根据文件id删除文件
    mortgageDelRollFile: "/mortgage/delRollFile",
    // 上传文件
    mortgageUploadFile: "/mortgage/uploadFile",
    // 下载模板
    mortgageDownload: "/mortgage/downTemplate",
    // 根据rollId判断是否可以推送账单
    mortgageApprovalFlag: "/mortgage/checkPushSubPayment",
    // 根据rollId推送账单
    mortgageApproval: "/mortgage/pushRollingPayment",
    // 根据rollId获取所有的推送记录
    mortgageApprovalList: "/mortgage/getMortgageSubMonthList",
    // 根据propId获取glAcct
    mortgageGlAcct: "/mortgage/glAcct",
    // 获取包含当前月的六个月的日期
    mortgageTitle: "/mortgage/getTitle",

    // ================================================================ 子合同
    // 根据主贷款id分页获取prop列表
    getRollingSubList: "/mortgage/getRollingSubList",
    // 新增贷款相关的prop
    saveRollingSub: "/mortgage/saveRollingSub",
    // 根据id批量删除贷款子合同
    delRollingSub: "/mortgage/delRollingSub",
    // 修改贷款子合同
    updateRollingSub: "/mortgage/updateRollingSub",
    // 根据id获取贷款子合同详情
    getRollingSubDetail: "/mortgage/getRollingSubDetail",
    // excel导入
    importSubExcel: "/mortgage/importSubExcel",
    // 一次性上传excel
    importAllExcel: "/mortgage/importAllExcel",
    // 分页获取sub列表按照prop loanNumber 排序
    getMortgageSubListByProp: "/mortgage/getMortgageSubListByProp",
};
